import { saasModernTheme } from 'common/theme/saasModern';

import {
  Box,
  Typography,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  TableBody,
  Button,
  styled,
} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { background, display, fontSize } from 'styled-system';

export const StyledTableHead = styled(TableHead)({
  background: 'white',
});

export const StyledTableBody = styled(TableBody)({
  position: 'relative',
});

export const StyledButtons = styled(Button)(({ theme }) => ({
  borderRadius: '12px',
  border: 'none',
  background: saasModernTheme.defaultBackgroundColor,
  color: 'white',
  padding: '10px 20px',
  fontFamily: saasModernTheme.fontFamily,
  fontStyle: 'normal',
  fontWeight: 600,
  fontSize: '12px',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '10px',
  width: '100%',
  height: '25px',
  textTransform: 'none',
  '&:hover': {
    background: saasModernTheme.customColor.gradiantColor,
  },
  '@media (max-width: 768px)': {
    fontSize: '8px',
    height: '20px',
    padding: '5px 10px',
  },
  '@media (min-width: 769px) and (max-width: 1024px)': {
    fontSize: '10px',
    height: '22px',
  },
}));

export const TableRows = styled(TableRow)({
  backgroundcolor: '  #ffffff',
});

export const StyledTableCell = styled(TableCell)(({ isMobile, isTablet }) => ({
  border: 'none',
  padding: isMobile ? '10px' : '32px 24px',
  fontWeight: 600,
  fontSize: isMobile ? '10px' : isTablet ? '12px' : '16px',
  lineHeight: '140%',
  letterSpacing: '-0.02em',
  color: '#111927',
}));

export const StyledTableCellPlan = styled(TableCell)(({ isMobile }) => ({
  border: 'none',
  padding: isMobile ? '10px' : '32px 24px',
  width: isMobile ? '100%' : 'auto',
}));

export const StyledTableCellPlanBox = styled(Box)(({ isMobile }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: isMobile ? '8px' : '16px',
  width: isMobile ? '100%' : '80%',
}));

export const StyledTableCellPlanText = styled(Box)(({ isMobile, isTablet }) => ({
  fontWeight: 600,
  position: 'relative',
  fontSize: isMobile ? '10px' : isTablet ? '12px' : '16px',
  lineHeight: '140%',
  letterSpacing: '-0.02em',
  color: '#111927',
}));

export const StyledTableCellPlanPrice = styled(Box)(({ isMobile, isTablet }) => ({
  fontWeight: 700,
  fontSize: isMobile ? '8px' : isTablet ? '9px' : '10px',
  lineHeight: '140%',
  letterSpacing: '0.08em',
  textTransform: 'none',
  color: '#636F81',
  textAlign: isMobile ? 'center' : 'left',
}));

export const StyledTableCellCatTitle = styled(TableCell)(({ theme }) => ({
  height: '64px',
  padding: 0,
  border: 'none',
}));

export const StyledTableRowCat = styled(TableRow)(({ theme }) => ({
  backgroundColor: '#919BAB14',
  width: '100%',
  height: '48px',
}));

export const StyledTableCellCat = styled(TableCell)(({ isTablet }) => ({
  padding: isTablet ? '12px 16px' : '16px 24px',
  borderBottom: '1px solid #e5e7eb',
}));

export const StyledCatText = styled(Typography)(({ isMobile, isTablet, isExpanded }) => ({
  fontWeight: isExpanded ? 600 : 400,
  fontSize: isMobile ? '12px' : isTablet ? '13px' : '14px',
  lineHeight: '140%',
  letterSpacing: '-0.02em',
  color: '#111927',
  display: 'block',
  marginBottom: '4px',
}));

export const StyledTableCellCatFeature = styled(TableCell)({
  padding: '26px 140px',
  borderBottom: '1px solid #e5e7eb',
  fontWeight: 600,
  color: '#111927',
  textAlign: 'center',

  '@media (max-width: 1440px)': {
    padding: '20px 100px',
  },

  '@media (max-width: 900px)': {
    padding: '20px 50px',
  },


  '@media (max-width: 600px)': {
    padding: '16px 24px',
    fontSize: '12px',
  },
});


export const StyledTableCellCatFeatureText = styled(Typography)(({ isTablet }) => ({
  color: '#636F81',
  fontSize: isTablet ? '10px' : '12px',
}));

export const StyledCheckIcon = styled(CheckIcon)(({ theme }) => ({
  color: '#111927',
  fontSize: '16px',
}));

export const StyledCloseIcon = styled(CloseIcon)(({ theme }) => ({
  color: '#111927',
  fontSize: '16px',
}));

export const StyledTitle = styled(Typography)(({ isMobile, isTablet }) => ({
  fontWeight: 600,
  fontSize: isMobile ? '24px' : isTablet ? '36px' : '48px',
  lineHeight: '140%',
  letterSpacing: '-1%',
  textAlign: 'center',
}));

export const StyledDescriptionText = styled(Typography)(({ isMobile, isTablet }) => ({
  fontWeight: 400,
  fontSize: isMobile ? '14px' : isTablet ? '16px' : '20px',
  lineHeight: '140%',
  letterSpacing: '-2%',
  textAlign: 'center',
  verticalAlign: 'middle',
  color: '#888C93',
}));

export const StyledTableContainer = styled(Box)(({ isMobile, isTablet }) => ({
  flexGrow: 1,
  marginTop: isMobile ? '5%' : isTablet ? '7%' : '10%',
  marginBottom: isMobile ? '10%' : isTablet ? '15%' : '20%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '20px',
  padding: isMobile ? '0 10px' : '0',
}));

export const StyledChip = styled(Button)(({ isMobile }) => ({
  width: isMobile ? '15%' : '25%',
  fontSize: '8px',
  height: '20%',
  marginLeft: '80%',
  borderRadius: '12px',
  background: 'white',
  overflow: 'hidden',
  display: isMobile ? 'none' : 'block',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    borderRadius: '12px',
    padding: '1px',
    background:
      'linear-gradient(90.11deg, #006FFF 50%, #FF6E72 74.95%, #FFB656 99.9%)',
    mask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
    maskComposite: 'exclude',
    pointerEvents: 'none',
  },
  '&:hover': {
    background:
      'linear-gradient(90.11deg,rgba(0, 110, 255, 0.15) 50%,rgba(255, 110, 115, 0.16) 74.95%,rgba(255, 182, 86, 0.14) 99.9%)',
  },
  '& a': {
    textDecoration: 'none',
    color: 'inherit',
    fontWeight: 'bold',
    '&:hover': {
      textDecoration: 'none',
    },
  },
  '@media (max-width: 900px)': {
    display: 'none',
  },
}));

export const StyledPlanBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'row',
  width: '100%',
}));

export const ResponsiveTable = styled(Box)(({ theme }) => ({
  width: '100%',
  overflowX: 'auto',
}));

export const StyledCatTextName = styled(Typography)(({ isMobile, isTablet, isExpanded, isBold }) => ({
  fontWeight: isBold ? 'bold' : 600,
  fontSize: isMobile ? '10px' : isTablet ? '11px' : '12px',
  lineHeight: '140%',
  letterSpacing: '-0.02em',
  color: '#111927',
  marginBottom: '8px',
  display: 'block',
  opacity: isExpanded !== undefined ? (isExpanded ? 1 : 0.7) : 1,
}));

export const StyledTableCellCat1 = styled(TableCell)(({ theme }) => ({
  padding: '16px 24px',
  borderBottom: '1px solid #e5e7eb',
  backgroundColor: '#919BAB14',
}));

export const StyledAccordion = styled(Box)(({ isMobile, isTablet, isExpanded }) => ({
  margin: isMobile ? '10px 0' : isTablet ? '15px 0' : '20px 0',
  '&:before': {
    display: 'none',
  },
  '& .MuiAccordionSummary-root': {
    backgroundColor: isExpanded ? 'rgba(0, 0, 0, 0.04)' : 'transparent',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.02)',
    },
  },
  transition: 'all 0.2s ease-in-out',
}));

export const StyledAccordionSummary = styled(Box)(({ isExpanded }) => ({
  minHeight: '48px',
  padding: '0 16px',
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
  '& .MuiAccordionSummary-expandIconWrapper': {
    transition: 'transform 0.2s ease-in-out',
    transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
  },
}));

export const StyledAccordionDetails = styled(Box)(({ isMobile, isTablet, isExpanded }) => ({
  padding: (isMobile || isTablet) ? '0 10px' : '16px',
  opacity: isExpanded ? 1 : 0,
  transition: 'opacity 0.2s ease-in-out',
}));

export const StyledStaticCategory = styled(Box)(({ isMobile, isTablet }) => ({
  margin: isMobile ? '10px 0' : isTablet ? '15px 0' : '20px 0',
  border: '1px solid #e0e0e0',
  borderRadius: '8px',
  overflow: 'hidden',
}));

export const StyledStaticCategoryHeader = styled(Box)({
  padding: '16px',
  backgroundColor: 'rgba(0, 0, 0, 0.04)',
  borderBottom: '1px solid #e0e0e0',
});

export const StyledStaticCategoryContent = styled(Box)(({ isMobile, isTablet }) => ({
  padding: (isMobile || isTablet) ? '10px' : '16px',
}));

export const StyledMobileFeatureCard = styled(Box)({
  border: '1px solid #e0e0e0',
  marginBottom: '8px',
  borderRadius: '8px',
  padding: '8px',
});

export const StyledMobileFeaturePlanBox = styled(Box)({
  flex: '1 1 calc(50% - 8px)',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  border: '1px solid #f0f0f0',
  borderRadius: '4px',
  padding: '4px',
});

export const StyledMobileFeaturePlanName = styled(Typography)({
  fontWeight: 'bold',
  marginBottom: '4px',
  textAlign: 'center',
  fontSize: '8px',
});

export const StyledMobileFeatureValueBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
});